import { MainLayout } from 'core/layouts';
import { moduleProviderFactory } from 'core/providers';
import { getModulesInfo, resolveApplicationUser } from 'core/utils';
import { Home } from 'modules/root/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app',
				pattern: '',
				beforeEnter: async (fromState, toState, routerStore) => {
					const { authStore } = routerStore.rootStore;

					try {
						await authStore.initialize();
					} catch (ex) {
						return Promise.reject(ex);
					}

					return Promise.resolve();
				},
				children: [
					{
						name: 'master.app.main',
						pattern: '',
						component: [MainLayout],
						isPrivate: true,
						beforeEnter: async (fromState, toState, routerStore) => {
							const { rootStore } = routerStore;
							try {
								await resolveApplicationUser(fromState, toState, routerStore);
								const { application } = moduleProviderFactory;
								const appModuleInfo = getModulesInfo(application.getModules());
								rootStore.initialize.menus([...appModuleInfo.menus]);
							} catch (ex) {
								return Promise.reject(ex);
							}

							return Promise.resolve();
						},
						children: [
							{
								name: 'master.app.main.home',
								pattern: '',
								component: Home,
							},
						],
					},
				],
			},
		],
	});
})();
